import { render, staticRenderFns } from "./TrendIcon.vue?vue&type=template&id=8037b6e0&scoped=true"
import script from "./TrendIcon.vue?vue&type=script&lang=js"
export * from "./TrendIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8037b6e0",
  null
  
)

export default component.exports